import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ITemplateEmail} from '../../../models/email-message';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { EditorModule } from 'primeng/editor';
import { InputTextModule } from 'primeng/inputtext';
import { instanceToInstance } from 'class-transformer';

@Component({
  selector: 'app-email-templates-editor',
  standalone: true,
  imports: [DialogModule, FloatLabelModule, FormsModule, NgIf, ButtonModule, ButtonGroupModule,
            EditorModule, InputTextModule
  ],
  templateUrl: './email-templates-editor.component.html',
  styleUrl: './email-templates-editor.component.scss'
})
export class EmailTemplatesEditorComponent 
{
  @Input() templateEmail: ITemplateEmail = {} as ITemplateEmail
  @Output() templateEmailChange: EventEmitter<ITemplateEmail> = new EventEmitter<ITemplateEmail>();
  @Output() saved: EventEmitter<ITemplateEmail> = new EventEmitter<ITemplateEmail>();
  @Output() cancelled = new EventEmitter();
  


  allowSave() : boolean
  {
    return this.templateEmail != null && this.templateEmail.subject != null && this.templateEmail.body != null
  }

  saveButtonPressed() : void
  {
    var copy = instanceToInstance(this.templateEmail);
    this.templateEmailChange.emit(copy);
    this.saved.emit(copy);
    this.templateEmail = {} as ITemplateEmail;
  }

  cancelButtonPressed() : void
  {
    this.cancelled.emit();
  }
}
